// extracted by mini-css-extract-plugin
export default {"wrapper":"MenuSeparator_wrapper__rGJ9y","line":"MenuSeparator_line__SMAmS"};